module.exports = __webpack_public_path__ + "static/media/menuw.be1c1b10.svg";